<template>
  <div class="basic_wrap">
    <bsHeader :title="$t('user.inviteRecord')" @backurl="$router.back()" />
    
    <!-- ================= 1. 顶部统计卡片 ================= -->
    <div class="stat_cards">
      <div class="stat_item">
        <div class="stat_label">{{ $t('utils.msg5') || '投资总额' }}</div>
        <div class="stat_val blue">{{ common.currency_symbol_basic() }}{{ common.precision_basic(datas.invest_money) }}</div>
      </div>
      <div class="stat_item">
        <div class="stat_label">{{ $t('utils.msg6') || '待收利息' }}</div>
        <div class="stat_val orange">{{ common.currency_symbol_basic() }}{{ common.precision_basic(datas.wait_interest) }}</div>
      </div>
      <div class="stat_item">
        <div class="stat_label">{{ $t('utils.msg10') || '投资笔数' }}</div>
        <div class="stat_val blue">{{ datas.invest_count }}</div>
      </div>
      <div class="stat_item">
        <div class="stat_label">{{ $t('utils.msg11') || '累计收益' }}</div>
        <div class="stat_val green">{{ common.currency_symbol_basic() }}{{ common.precision_basic(datas.shouyi) }}</div>
      </div>
    </div>

    <!-- ================= 2. 分类筛选 Tabs ================= -->
    <div class="filter_tabs">
      <div class="tab_item" :class="{ active: activeStatus === '' }" @click="changeStatus('')">{{ $t('tabs.all') || 'All' }}</div>
      <div class="tab_item" :class="{ active: activeStatus === 0 }" @click="changeStatus(0)">{{ $t('tabs.ongoing') || '进行中' }}</div>
      <div class="tab_item" :class="{ active: activeStatus === 1 }" @click="changeStatus(1)">{{ $t('tabs.done') || '已完成' }}</div>
    </div>

    <!-- ================= 3. 投资记录列表 ================= -->
    <div class="list_wrap">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('utils.noData')"
        @load="onLoad"
      >
        <div class="record_card" v-for="(item, index) in list" :key="index">
          <!-- 卡片上半部分：固定显示 -->
          <div class="card_top">
            <div class="proj_img">
              <img :src="item.img" alt="cover">
            </div>
            <div class="proj_info">
              <div class="proj_title">{{ item.title }}</div>
              <div class="info_grid_2">
                <div class="grid_item">
                  <div class="g_label">{{ $t('invest.amount') }}</div>
                  <div class="g_val"> {{ common.currency_symbol_basic() }}{{ common.precision_basic(item.money) }}</div>
                </div>
                <div class="grid_item">
                  <div class="g_label">{{ $t('utils.msg6') }}</div>
                  <div class="g_val orange">{{ common.currency_symbol_basic() }}{{ common.precision_basic(item.total_interest) }}</div>
                </div>
                <div class="grid_item">
                  <div class="g_label">{{ $t('utils.msg8') || '投资时间' }}</div>
                  <div class="g_val gray">{{ item.time_actual }}</div>
                </div>
                <div class="grid_item">
                  <div class="g_label">{{ $t('invest.endTime') }}</div>
                  <div class="g_val gray">{{ item.time2_actual }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 状态与详情按钮行 -->
          <div class="card_mid">
            <div class="status_tag" :class="item.status === 0 ? 'ongoing' : 'done'">
              <span class="dot"></span>
              {{ item.status === 0 ? $t('tabs.ongoing') : $t('tabs.done') }}
            </div>
            <div class="detail_btn" @click="toggleDetail(index)">
              <span>{{ isExpanded[index] ? $t('utils.msg9') || '收起' : $t('utils.msg9') || '详情' }}</span>
              <span class="arrow" :class="{ up: isExpanded[index] }">^</span>
            </div>
          </div>

          <!-- 卡片下半部分：详情数据区 (2x3网格) - 使用过渡动画 -->
          <div class="card_detail" :class="{ show: isExpanded[index] }">
            <div class="detail_grid_2x3">
              <div class="d_item">
                <div class="d_val">{{ common.currency_symbol_basic() }}{{ common.precision_basic(item.money) }}</div>
                <div class="d_label">{{ $t('invest.amount') }}</div>
              </div>
              <div class="d_item">
                <div class="d_val">VIP{{ item.level || 1 }}</div>
                <div class="d_label">{{ $t('utils.lunlog30') || '最低等级' }}</div>
              </div>
              <div class="d_item">
                <div class="d_val">{{ item.day }}{{ item.type==3 ? $t('index.hour') : $t('index.day') }}</div>
                <div class="d_label">{{ $t('invest.cycle') }}</div>
              </div>
              <div class="d_item">
                <div class="d_val blue">{{ item.rate }}%</div>
                <div class="d_label">{{ item.type==1 ? $t('index.dailyRate') : $t('index.rate') }}</div>
              </div>
              <div class="d_item">
                <div class="d_val">{{ common.currency_symbol_basic() }}{{item.days}}/{{ $t('index.day') }}</div>
                <div class="d_label">{{ $t('invest.income') }}</div>
              </div>
              <div class="d_item">
                <div class="d_val black">{{ common.currency_symbol_basic() }}{{ common.precision_basic(item.total) }}</div>
                <div class="d_label">{{ $t('utils.goodszong') }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue';
import Fetch from '../../utils/fetch';
import { List } from 'vant';

Vue.use(List);

export default {
  name: "InvestRecord",
  components: { bsHeader },
  data() {
    return {
      // 统计相关
      total_money: 0,
      total_interest: 0,
      total_count: 0,
      total_yield: 0,

      // 列表与分页
      list: [],
	  datas:[],
      // 存储从后端拉取的【原始】全部数据，用于前端过滤
      rawAllList: [], 
      page: 1,
      listRows: 8,
      loading: false,
      finished: false,

      // 筛选状态 (空字符串:全部, 0:进行中, 1:已完成)
      activeStatus: '',

      // 列表项展开状态
      isExpanded: {}
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    // this.getStatistics();
    // 页面加载时触发一次请求，把数据拉到本地
    this.loading = true;
    this.fetchAllData();
  },
  methods: {
    // 1. 获取顶部统计数据
    // getStatistics() {
    //   Fetch('/user/investRecordStat').then((r) => {
    //     if (r.data) {
    //       this.total_money = r.data.total_money || 0;
    //       this.total_interest = r.data.total_interest || 0;
    //       this.total_count = r.data.total_count || 0;
    //       this.total_yield = r.data.total_yield || 0;
    //     }
    //   });
    // },

    // 2. 切换状态分类 (前端过滤)
    changeStatus(status) {
      if (this.activeStatus === status) return;
      this.activeStatus = status;
      
      // 切换分类时，重置为第一页，并清空当前显示列表
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.isExpanded = {};
      
      // 根据当前选中的状态，从本地【原始全部数据】中过滤出新的显示列表
      this.filterAndPaginateData();
    },

    // 3. 从后端请求全部数据（只会请求这一次）
    fetchAllData() {
      Fetch('/user/investRecord', {
        page: 1,
        listRows: 99999 // 传入一个很大的数字，请求全部数据
      }).then(r => {
        this.loading = false;
        // 保存全部原始数据
        this.rawAllList = r.data.list || [];
        this.datas=r.data.data || [];
        // 首次拿到数据后，根据当前 activeStatus 过滤第一页显示
        this.filterAndPaginateData();
      }).catch(() => {
        this.loading = false;
      });
    },

    // 4. 核心：前端过滤 + 分页逻辑
    filterAndPaginateData() {
      let filteredList = [];

      // 第一步：根据 activeStatus 状态进行前端过滤
      if (this.activeStatus === '') {
        // 如果选的是"全部"，不过滤
        filteredList = this.rawAllList;
      } else {
        // 如果选的是"进行中(0)"或"已完成(1)"，严格过滤
        filteredList = this.rawAllList.filter(item => item.status === this.activeStatus);
      }

      // 第二步：对过滤后的数据做前端模拟分页 (van-list 的 onLoad 配合)
      // 计算总条数
      const totalLength = filteredList.length;
      
      if (totalLength === 0) {
        this.finished = true;
        this.list = [];
        return;
      }

      // 根据当前 page 和 listRows 截取需要展示的数据
      const start = (this.page - 1) * this.listRows;
      const end = start + this.listRows;
      const pageData = filteredList.slice(start, end);

      // 如果截取出来的数据为空，说明已经没有下一页了
      if (pageData.length === 0) {
        this.finished = true;
        this.loading = false;
        return;
      }

      // 将截取的数据塞入显示列表
      for (let i = 0; i < pageData.length; i++) {
        this.list.push(pageData[i]);
        this.$set(this.isExpanded, this.list.length - 1, false);
      }

      // 判断是否全部加载完毕
      if (this.list.length >= totalLength) {
        this.finished = true;
      } else {
        this.page = this.page + 1; // 加载下一批
      }
      this.loading = false;
    },

    // 5. 配合 van-list 的下拉到底部触发加载
    onLoad() {
      if (this.finished || this.loading) return;
      
      // 如果 rawAllList 为空，说明还没请求过接口，先去请求一次
      if (this.rawAllList.length === 0) {
        this.loading = true;
        this.fetchAllData();
        return;
      }

      // 否则，继续执行本地分页逻辑
      this.filterAndPaginateData();
    },

    // 6. 切换单个卡片的展开/收起
    toggleDetail(index) {
      this.$set(this.isExpanded, index, !this.isExpanded[index]);
    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  padding-bottom: 60px;
  min-height: 100vh;
  background: #f4f7fc; /* 浅蓝色背景 */
}

/* ================= 顶部统计卡片 ================= */
.stat_cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 16px;
  margin-top: 10px;

  .stat_item {
    background: #ffffff;
    border-radius: 12px;
    padding: 14px 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
    .stat_label {
      font-size: 12px;
      color: #64748b;
      margin-bottom: 4px;
    }
    .stat_val {
      font-size: 16px;
      font-weight: 700;
      &.blue { color: #2563eb; }
      &.orange { color: #ea580c; }
      &.green { color: #16a34a; }
    }
  }
}

/* ================= 分类 Tabs ================= */
.filter_tabs {
  display: flex;
  gap: 10px;
  padding: 0 16px 16px;
  
  .tab_item {
    padding: 8px 20px;
    background: #ffffff;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    cursor: pointer;
    border: 1px solid transparent;
    transition: all 0.2s;
    
    &.active {
      background: #2563eb;
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
    }
  }
}

/* ================= 列表卡片 ================= */
.list_wrap {
  padding: 0 16px 20px;
}

.record_card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 16px;
  margin-bottom: 16px;
  overflow: hidden;
  border: 1px solid #f1f5f9;

  /* 卡片头部：图 + 基础信息 */
  .card_top {
    display: flex;
    gap: 14px;
    margin-bottom: 14px;
    
    .proj_img {
      width: 52px; height: 52px;
      border-radius: 12px;
      overflow: hidden;
      flex-shrink: 0;
      img { width: 100%; height: 100%; object-fit: cover; }
    }
    .proj_info {
      flex: 1;
      .proj_title {
        font-size: 15px; font-weight: 700; color: #111;
        margin-bottom: 10px;
      }
      .info_grid_2 {
        display: grid; grid-template-columns: 1fr 1fr; gap: 6px 12px;
        .grid_item {
		  line-height: 24px;
          .g_label { font-size: 12px; color: #000; margin-bottom: 2px;font-weight: 700; }
          .g_val { font-size: 12px; font-weight: 400; color: #1e293b; 
            &.orange { color: #ea580c; }
            &.gray { color: #64748b; font-weight: 500;}
          }
        }
      }
    }
  }

  /* 状态行 + 详情按钮 */
  .card_mid {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 14px;
    border-bottom: 1px solid #f1f5f9;

    .status_tag {
      display: flex; align-items: center; gap: 6px;
      font-size: 12px; font-weight: 600;
      padding: 4px 12px; border-radius: 12px;
      .dot { width: 6px; height: 6px; border-radius: 50%; display: inline-block; }
      
      &.ongoing { background: #dcfce7; color: #16a34a; .dot { background: #16a34a; } }
      &.done { background: #e0f2fe; color: #0284c7; .dot { background: #0284c7; } }
    }

    .detail_btn {
      display: flex; align-items: center; gap: 6px;
      padding: 6px 14px; border-radius: 16px;
      border: 1px solid #93c5fd; color: #2563eb;
      font-size: 12px; font-weight: 500; cursor: pointer;
      transition: all 0.2s;
      &:active { background: #eff6ff; }
      
      .arrow {
        display: inline-block;
        transition: transform 0.3s ease;
        font-weight: 700; font-size: 14px;
        &.up { transform: rotate(180deg); }
      }
    }
  }

  /* 卡片详情区 (默认隐藏) */
  .card_detail {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease, margin 0.3s;
    opacity: 0;
    margin-top: 0;

    &.show {
      max-height: 500px; /* 足够展开即可 */
      opacity: 1;
      margin-top: 16px;
    }

    .detail_grid_2x3 {
      display: grid; grid-template-columns: 1fr 1fr; gap: 10px;
      .d_item {
        background: #f8fafc; border-radius: 10px; padding: 10px 4px; text-align: center;
        .d_val { font-size: 14px; font-weight: 700; color: #111; margin-bottom: 4px;
          &.blue { color: #2563eb; } &.black { color: #1e293b; }
        }
        .d_label { font-size: 11px; color: #64748b; }
      }
    }
  }
}

/* 清除 Vant 默认样式干扰 */
/deep/ .van-cell { padding: 0; background: transparent; }
</style>